"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Generator = void 0;
const index_1 = require("./index");
const configurable_1 = require("../configurable");
class Generator {
    static create(type, options) {
        try {
            switch (type) {
                case 'aison-application':
                    return new index_1.AisonApplicationGenerator();
                default:
                    throw new configurable_1.InvalidConfigurationException({ type: 'invalid' });
            }
        }
        catch (e) {
            throw new configurable_1.InvalidConfigurationException(e.details.type ? e.details : { adapter: e.details });
        }
    }
}
exports.Generator = Generator;
//# sourceMappingURL=base-generator.js.map